import { useRef, useState } from "react";
import { toast } from "sonner";
import { ClipboardCheck, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { VehicleInspectionForm } from "./VehicleInspectionForm";
import { itemsFor, CarDamageDiagram } from "./VehicleDamageDiagram";
import { api, fileUrl } from "../lib/api";

const toFile = async (dataUrl, i) => new File([await (await fetch(dataUrl)).blob()], `inspection-${i + 1}.jpg`, { type: "image/jpeg" });

export const RentedInspection = ({ label, stage, date, value, onChange, tid }) => {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const ref = useRef(null);
  const save = async () => {
    const insp = ref.current?.getInspection();
    const shots = ref.current?.getPhotos() || [];
    if (!insp && !shots.length) { toast.error("سجّل حالة المركبة أولاً"); return; }
    setBusy(true);
    try {
      const photos = [];
      for (let i = 0; i < shots.length; i++) photos.push((await api.uploadFile(await toFile(shots[i], i))).attachment_id);
      onChange({ ...(insp || { checklist: {}, damages: [], note: "", odometer: null }), photos, at: date || new Date().toISOString().slice(0, 10) });
      setOpen(false);
    } catch { toast.error("تعذّر رفع صور الفحص"); } finally { setBusy(false); }
  };
  const items = itemsFor(value?.kind);
  const ok = value ? items.filter((c) => value.checklist?.[c.key]).length : 0;
  return (
    <div className="space-y-1.5 rounded-xl border border-slate-200 p-2.5" data-testid={tid}>
      <div className="flex items-center justify-between gap-2">
        <span className="text-xs font-semibold text-slate-600">{label}</span>
        <Button type="button" size="sm" variant="outline" className="h-7 gap-1 text-xs" onClick={() => setOpen(true)} data-testid={`${tid}-open`}>
          <ClipboardCheck className="h-3.5 w-3.5" /> {value ? "فحص جديد" : "فحص حالة المركبة"}</Button>
      </div>
      {value && (
        <div className="space-y-1 text-[11px] text-slate-600" data-testid={`${tid}-summary`}>
          <p>{value.kind === "moto" ? "دراجة نارية · " : ""}سليم {ok}/{items.length} · أضرار {value.damages?.length || 0}{value.odometer ? ` · العداد ${value.odometer}` : ""}{value.at ? ` · ${value.at}` : ""}</p>
          {!!value.damages?.length && <div className="max-w-[220px]"><CarDamageDiagram kind={value.kind} damages={value.damages} /></div>}
          {value.note && <p className="text-slate-500">{value.note}</p>}
          {!!value.photos?.length && <div className="flex flex-wrap gap-1">{value.photos.map((p) => <a key={p} href={fileUrl(p)} target="_blank" rel="noreferrer"><img src={fileUrl(p)} alt="" className="h-10 w-10 rounded object-cover" /></a>)}</div>}
        </div>)}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent dir="rtl" className="max-h-[92vh] overflow-y-auto sm:max-w-lg" data-testid={`${tid}-dialog`}>
          <DialogHeader className="pe-8 text-start"><DialogTitle>{label}</DialogTitle></DialogHeader>
          {open && <VehicleInspectionForm ref={ref} stage={stage} kind={value?.kind || "moto"} />}
          <Button className="w-full gap-1.5" disabled={busy} onClick={save} data-testid={`${tid}-save`}>{busy && <Loader2 className="h-4 w-4 animate-spin" />} حفظ الفحص</Button>
        </DialogContent>
      </Dialog>
    </div>
  );
};
